<template>
  <div class="video">
    <headd :mobile_title="mobile_title"></headd>

    <div class="videolist">
      <div class="kv">
        <!-- <img :src="csbanner.pagevaluepc" /> -->
        <img :src="csbanner.pagevaluepc" class="hidden-xs" />
        <img :src="csbanner.pagevalue" class="hidden-lg hidden-md hidden-sm " />
      </div>
      <div class="vlist container">
        <div class="row">
          <div
            class="vlist_item col-lg-6 col-md-6 col-sm-6 col-xs-6"
            v-for="item in vlist"
            @click="govideodetail(item.id)"
          >
            <div
              class="root"
              :style="{ backgroundImage: 'url(' + item.photopath + ')' }"
            >
              <img :src="item.photopath" />
            </div>

            <div class="title">{{ item.title }}</div>
          </div>
        </div>
      </div>
      <el-dialog title="" :visible.sync="dialogFormVisible" width="7.5rem">
        <div class="video_open">
          <video :src="video_url" autoplay="autoplay"></video>
        </div>
      </el-dialog>
    </div>
    <foot></foot>
  </div>
</template>

<script>
import { getvideosPageData, getcsvideoscate } from "./api/api"; //引入api里面定义的方法
import headd from "@/components/head";
import foot from "@/components/foot";
export default {
  data() {
    return {
      mobile_title: "财税课堂",
      csbanner: "",
      vlist: [],
      pageindex: 1,
      flag: false,
      video_url: "",
      dialogFormVisible: false
    };
  },
  metaInfo: {
    title: "马上创业网 专注企业注册的网站", // set a title
    meta: [
      {
        // set meta
        name: "keyWords",
        content:
          "马上创业网，注册公司，代理记账，上海注册公司，注册公司流程，注册公司费用，商标注册，法务咨询，法律服务，个体工商户注册，许可证办理，专业法律，社保，公积金，专利申请，医疗器械许可证，ICP电信增值许可证，食品经营许可证，酒类经营许可证，餐饮服务许可证，道路运输许可证，广播电视节目许可证，海关资质，进出口许可证，商标设计，logo设计，VI设计，海报设计，包装设计，APP开发，微信运营，网站定制，版权服务，软件著作权，发明专利，外观设计专利，实用新型专利，商标转让，驳回复审，注销公司，股权变更，经营范围变更，股权协议，股权转让，劳务派遣"
      },
      {
        name: "description",
        content:
          "马上创业网是一个专为中小企业服务的综合平台，主要提供医疗器械服务、审计服务、知识产权服务、财税咨询、注册公司、代理记账、商标注册、专利申请、社保代理、法务代理等一站式的服务，借助移动互联网技术，改善并升级企业服务状态，实现了新形势下中小企业所需要的企业服务。"
      }
    ]
  },
  components: { headd, foot },
  watch: {
    dialogFormVisible(val, oldval) {
      if (!val) {
        this.video_url = "";
      }
    }
  },
  onShow() {
    // this.vlist = [];
    // this.pageindex = 1;
    // (this.flag = false), this.videosPageData();
    // this.govlist();
  },
  mounted() {
    this.videosPageData();
    this.govlist();
  },
  methods: {
    govideo(url, img_url) {
      //console.log(url)
      this.video_url = url;
      //this.dialogFormVisible = true;
      this.$router.push({
        name: "videoplay",
        params: {
          url: url,
          img_url: img_url
        }
      });
    },
    govideodetail(dtype){
			   
				  console.log(dtype) 
				 
			// this.$router.push({
      //   name: "videolistdetail",
      //   params: {
      //     dtype: dtype,
          
      //   }
      // });
    this.$router.push({
        path: "videolistdetail",
        query: {
          dtype: dtype
        }
      });

		},
    async videosPageData() {
      var _self = this;
      const res = await getvideosPageData();
      var data = res.data.data;
      //console.log(data)
      _self.csbanner = data.csbanner;
    },
    async govlist() {
      var _slef = this;
      var data = {
        page: _slef.pageindex,
        limit: 30
      };
      const res = await getcsvideoscate(data);
      _slef.vlist = _slef.vlist.concat(res.data.data.csvideos);
      console.log(_slef.vlist);

      if (res.data.data.csvideos.length < 30) {
        _slef.flag = true;
      }
    }
  },
  onReachBottom() {
    if (!this.flag) {
      this.pageindex++;
      this.govlist();
    }
  }
};
</script>

<style lang="less" scoped>
.video {
}
.videolist {
  padding: 0 0 0.3rem 0;
  flex-direction: column;
  width: 100%;

  .kv {
    width: 100%;
    margin: 0 0 0.32rem 0;
    img {
      width: 100%;
    }
  }
  .vlist {
    margin: 0.32rem auto;
    @media (max-width: 991px) {
      padding: 0;
      width: 6.86rem;
    }
    .vlist_item {
      cursor: pointer;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
      margin-bottom: 0.2rem;
      .root {
        width: 100%;
        height: 3.2rem;
        background-position: center center;
        background-size: cover;
        background-repeat: no-repeat;
        overflow: hidden;
        cursor: pointer;
        @media (max-width: 991px) {
          // height: 2.2rem;
          height: 1.8rem;
        }
        img {
          width: 100%;
          height: 100%;
          opacity: 0;
          position: relative;
        }
      }
      .title {
        margin: 0.1rem 0;
        width: 100%;
        height: 0.66rem;
        font-size: 0.2rem;
        line-height: 0.33rem;
        text-align: center;
        justify-content: center;
        align-items: center;
        @media (max-width: 991px) {
          font-size: 0.26rem;
        }
      }
    }
  }
}
.video_open {
  video {
    width: 100%;
  }
}
@media (max-width: 991px) {
  .head_line {
    border-bottom: 0rem solid #ccc;
    padding-bottom: 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/videolist.vue